import styled from '@emotion/styled';
import { createElement } from 'react';

type Props = {
  size: number;
  className?: string;
};

const GoogleAdsIcon = ({ size, className }: Props) => {
  return (
    <Root
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
      version="1.1"
      id="Artwork"
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 192 192"
      enable-background="new 0 0 192 192"
      xmlSpace="preserve"
    >
      <g>
        <rect
          x="8"
          y="62.52"
          transform="matrix(0.5 -0.866 0.866 0.5 -46.2127 103.666)"
          fill="#FBBC04"
          width="117.33"
          height="58.67"
        />
        <path
          fill="#4285F4"
          d="M180.07,127.99L121.4,26.38c-8.1-14.03-26.04-18.84-40.07-10.74c-14.03,8.1-18.84,26.04-10.74,40.07   l58.67,101.61c8.1,14.03,26.04,18.83,40.07,10.74C183.36,159.96,188.16,142.02,180.07,127.99z"
        />
        <circle fill="#34A853" cx="37.34" cy="142.66" r="29.33" />
      </g>
    </Root>
  );
};

const Root = styled('svg')();

export default GoogleAdsIcon;
